<script>
  import Button from '@components/buttons/button.svelte'
  import Text from '@components/general/text.svelte'
  import Tag from '@components/general/tag.svelte'
  import Image from '@components/general/image.svelte'
  import { CirclePlay, Play } from 'lucide-svelte'
  import { colors } from '@lib/utils/colors'
  import { cn } from '@lib/utils'

  let { video, label = "Video" } = $props()

  let color = $derived(video?.color || 'gray')
  let hasThumbnail = $derived(!!video?.vimeo_image_url)
</script>

<Button
  variant="naked"
  path={`/videos/${video.id}`}
  class={cn('flex flex-col h-full min-h-0', 'group items-start w-full ring-2 ring-offset-4', colors[color]?.ring, colors[color]?.hover_ring)}
>
  <div class="relative block w-full overflow-hidden rounded-lg border border-solid border-gray-200/70 bg-gray-100 aspect-video">
    {#if hasThumbnail}
      <Image src={video.vimeo_image_url} alt={video.name} loading="lazy" class="absolute inset-0 z-0 h-full w-full rounded-none object-cover" />
      <span aria-hidden="true" class="pointer-events-none absolute inset-0 z-10 bg-black/0 transition-colors group-hover:bg-primary-100/30"></span>
    {:else}
      <div class={cn('inset-0 z-0 h-full w-full relative flex items-center justify-center', colors[color]?.gradient)}>
        <CirclePlay size={48} class="text-gray-400/40 group-hover:opacity-0 transition-opacity" strokeWidth={1} />
      </div>
    {/if}
    <Play size={40} class="absolute left-1/2 top-1/2 z-20 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white shadow-lg p-3 text-gray-700 group-hover:scale-110 transition-transform" />
    <Text variant="label" as="span" class={cn('absolute top-4 left-4 z-20 uppercase tracking-wider', hasThumbnail ? 'bg-black/40 text-white/95 px-2 py-0.5 rounded' : 'text-gray-600')}>{label}</Text>
  </div>
  <div class="flex flex-1 flex-col gap-1.5 items-start p-1 w-full min-h-0">
    <Text variant="section_title" text={video.name} />
    {#if video.tags?.length > 0}
      <div class="flex flex-wrap gap-1">
        {#each video.tags as tag (tag.id)}
          <Tag tag={tag} size="xs" class="rounded-md px-[6px]" variant="faint" />
        {/each}
      </div>
    {/if}
  </div>
</Button>
